import React from "react";
// BASE Components
import BASELoading from "../../../../../../../@BASE/core/BASELoading";
// Material-UI Components
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
// Custom Components
import { ImageAttribution } from "../components/ImageAttribution";
import Instructions from "../components/Instructions";

export default function IntroCarousel(props) {
  const { data, dir, ins = [], course, comments = [] } = props;
  const tl = `${dir === "rtl" ? "text-18" : "text-14"} ${course?.language?.acronym}`.trim();

  if (!data) {
    return <BASELoading />;
  }

  // filer comments by component_id
  const componentCommentsCount = (component) => {
    return comments.filter(
      (comment) =>
        comment.component === component && comment.internality !== true
    ).length;
  };

  return (
    <div>

      <Instructions
        ins={ins}
        course={course}
        dir={dir}
        tl={tl}
        componentCommentsCount={componentCommentsCount}
      />
      <Typography className="text-16 font-bold p-16 pb-0">
        Page Content:
      </Typography>

      {data.core.map((slide, index) => (
        <div key={index}>
          <Typography className="text-14 font-bold p-16 pb-0">
            Slide {index + 1}:
          </Typography>
          <Grid container spacing={0}>
            <Grid item xs={12} className="mx-16">
              <ImageAttribution attribution={slide.media} tl={tl} dir={dir} />
            </Grid>
          </Grid>

          <Paper elevation={0} variant="outlined" square className="p-16 m-16">
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography className="text-14 font-bold m-0">
                  Text Content:
                </Typography>
                <Divider className="my-16" />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={4} sm={2}>
                <Typography className="text-14 font-semibold m-0">
                  Title:
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                <Typography className="m-0">{slide.title}</Typography>
              </Grid>
              <Grid item xs={4} sm={2}>
                <Typography className="text-14 font-semibold m-0">
                  Description:
                </Typography>
              </Grid>
              <Grid item xs={8} sm={10}>
                <Typography
                  className="m-0 wysiwyg"
                  dangerouslySetInnerHTML={{ __html: slide.description }}
                />
              </Grid>
            </Grid>
          </Paper>
        </div>
      ))}
    </div>
  );
}
